import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import Cart from '../interfaces/cart.interface';
import Customer from '../interfaces/customer.interface';
import Order from '../interfaces/order.interface';
import RootState from '../interfaces/root.interface';
import Shipping from '../interfaces/shipping.interface';

const initialState: Cart = {
  orders: []
};
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setOrderId: (state, action: PayloadAction<any>) => ({ ...state, orderId: action.payload }),
    setSessionId: (state, action: PayloadAction<any>) => ({ ...state, sessionId: action.payload }),
    setCustomer: (state, action: PayloadAction<Customer>) => ({
      ...state,
      customer: action.payload,
    }),
    setShipping: (state, action: PayloadAction<Shipping>) => ({
      ...state,
      shipping: action.payload,
    }),
    addOrder: (state, action: PayloadAction<Order>) => {
      const orders = state.orders;

      return {
        ...state,
        orders: [...orders, action.payload],
      };
    },
    deleteOrder: (state, action: PayloadAction<any>) => {
      const orderIndex = action.payload;
    
      const orders = [
        ...state.orders.slice(0, orderIndex),
        ...state.orders.slice(orderIndex + 1),
      ];
      
      return {
        ...state,
        orders
      };
    },
    incQty(state, action: PayloadAction<number>) {
      return { 
        ...state, 
        orders: state.orders.map((order: Order, i: number) => {
            return i === action.payload ? {...order, qty: (order.qty || 0 ) + 1} : order
          }
        )
     }
    },
    decQty(state, action: PayloadAction<number>) {
      return { 
        ...state, 
        orders: state.orders.map((order: Order, i: number) => {
            return (i === action.payload && order.qty !== 1) ? {...order, qty: (order.qty || 0 ) - 1} : order
          }
        )
     }
    },
    resetCart(state) {
      return {
        orders: [],
        customer: state.customer
      };
    },
    updateOrder(state, action: PayloadAction<any>) {
      //data: this.state.data.map(el => (el.id === id ? {...el, text} : el))
      const data = [...state.orders];
      const orderIndex = state.orders.findIndex(o => o.id === action.payload.id);
      data[orderIndex] = action.payload;
      return {
        ...state,
        orders: data
      }
    }
  },
});

export const getCart = (state: RootState) => state.cart;

export default cartSlice;
